import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { DOCUMENT } from '@angular/common';
import { SearchService } from 'src/app/shared/services/search.service';
import { LocalizationService } from '../../services/localization.service';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { PortalLoggedinUsers } from 'src/app/shared/services/portal-loggedin-users.service';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';
import { RouterService } from 'src/app/shared/services/router.service';
import { MatDialog } from '@angular/material/dialog';
import { PersonalizationPopup } from '../personalization-popup/personalization-popup';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: [
    './account-info.component.scss',
    './account-info.component.en.scss',
  ],
})
export class AccountInfoComponent implements OnInit {
  @Input() generalSettingsData: any;
  name: string = '';

  constructor(
    private authService: AuthService,
    private personalizationPopup: MatDialog,
  ) {}

  ngOnInit(): void {}

  onLogout(): void {
    return this.authService.logout(PortalLogOutExitCode.LogOutByUser);
  }

  changeSessionView(sesionEnum: any) {
    return this.authService.changeSessionView(sesionEnum);
  }

  openAccountSettingsPopup() {
    this.personalizationPopup.open(PersonalizationPopup);
  }
}
